import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import React, { Fragment } from 'react';
import { useService } from '~/services/service.base';
import { ServiceMediaViewer } from '~/services/service.media.viewer';
import { MediaSwiper } from '~/views/organisms/media-swiper/media.swiper';
import { useActions } from '~/pages/funds/books/cover-book/useActions';
import { useElements } from '~/pages/funds/books/cover-book/useElements';
import { useFileInfo } from '~/shared/hooks';
import { AuthService } from '~/services/service.auth';
export const PageFundsCoverBook = observer(() => {
    const serviceMediaViewer = useService(ServiceMediaViewer);
    const { closeImageHandler, downloadImageHandler } = useActions();
    const { content } = useElements();
    const { fileInfoHandler, fileInfoContent } = useFileInfo();
    const authService = useService(AuthService);
    return (_jsxs(Fragment, { children: [content, serviceMediaViewer.mediaViewOpenService.open && serviceMediaViewer.openedItem && (_jsx(MediaSwiper, { closeButtonHandler: closeImageHandler, infoButtonHandler: fileInfoHandler, downloadButtonHandler: authService.isLogged ? downloadImageHandler : undefined, items: [serviceMediaViewer.openedItem] })), fileInfoContent] }));
});
